import { useSelector } from 'react-redux';
import { SharedStoreState, SimulationMultiSelectDialogState } from '../types';

export const useSelectSimulationMultiSelectDialog =
	(): SimulationMultiSelectDialogState => {
		return useSelector(
			(state: SharedStoreState) => state.simulationMultiSelectDialog,
		);
	};
